import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';
import * as Provider from 'providers/components/form';

const ProvidersFormView = ({
  t,
  provider,
  company,
  handleSubmit,
  handleValueChange,
  handleValidation,
  subcompany,
  isFetching,
  isSubmitted,
  handleGroupChange, //Groups
  handleCustomFieldChange, //Groups
  groups, //Groups
  isSaving,
}) => (
  <Common.Wrapper fluid={true}>
    {/* <Common.Header title={t("providers.title")} /> */}
    <div className="col-12">
      <Common.Portlet
        title={
          t('menu.configuration') +
          ' > ' +
          t('projects.title') +
          ' > ' +
          t(provider.id ? 'providers.edit' : 'providers.add')
        }
        icon={'archive'}
      >
        <Provider.Form
          company={company}
          handleSubmit={handleSubmit}
          handleValidation={handleValidation}
          handleValueChange={handleValueChange}
          isSubmitted={isSubmitted}
          isSaving={isSaving}
          subcompany={subcompany}
          handleGroupChange={handleGroupChange} //Groups
          handleCustomFieldChange={handleCustomFieldChange} //Groups
          groups={groups} //Groups
          values={provider}
        />
        <Common.LoaderOverlay show={isFetching} />
      </Common.Portlet>
    </div>
  </Common.Wrapper>
);

export default translate()(ProvidersFormView);



// WEBPACK FOOTER //
// src/modules/secured/modules/providers/components/ProviderFormView.js